import './App.css';
import { MdEmail } from 'react-icons/md';
import { FaLinkedin, FaInstagram } from 'react-icons/fa';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <header className="App-header">
              <p className="title">
                Christian Kroeber
              </p>
              <p className="subtitle">
                Entrepreneur | Moderator | Investor
              </p>
              <div className="social-icons">
                <a href="mailto:hello@christiankroeber.com" aria-label="Email">
                  <MdEmail className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/in/christiankroeber/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedin className="social-icon" />
                </a>
                <a href="https://www.instagram.com/christiankroeber/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram className="social-icon" />
                </a>
              </div>
            </header>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
